import { apiFetch } from "@/utils";
import store from "@/store/store";
import { getCurrentModuleUrl } from ".";

function getModules(all = false) {
  return apiFetch("module/get" + (all ? "/all" : ""));
}

function getModuleGroups(all = false) {
  return apiFetch("module/get/groups");
}

function updateGroup(moduleId, groupId) {
  return apiFetch("module/group/update?moduleId=" + moduleId + "&groupId=" + groupId);
}

function updatePosition(moduleId, position) {
  return apiFetch("module/position/update?moduleId=" + moduleId + "&position=" + position);
}

function getModulesInGroups(all = false) {
  return new Promise((resolve, reject) => {
    apiFetch("module/get" + (all ? "/all" : "")).then(response => {
      let groups = [];
      let i = 0;

      response.forEach(module => {
        // Si le groupe n'existe pas dans la liste
        if (groups.filter(e => e.NomGroupe == module.NomGroupe).length == 0) {
          let newGroup = {
            NomGroupe: module.NomGroupe,
            PositionGroupe: module.PositionGroupe,
            Modules: [],
            IdFor: i
          };
  
          // On l'ajoute à la liste des modules
          groups.push(newGroup);

          // Incrément i
          i = i + 1;
        }
        // On récupère le groupe actif
        let currentGroup = groups.find(e => e.NomGroupe == module.NomGroupe);

        // On ajoute les éléments dans ces modules
        currentGroup.Modules.push({
          Id: module.Id,
          Title: module.Title,
          Desc: module.Desc,
          Url: module.Url,
          AdminOnly: module.AdminOnly,
          Position: module.Position,
          IsPublic: module.IsPublic
        });
      });


      // Tri des tableaux
      groups.forEach(g => {
        g.Modules.sort((a, b) => { return a.Position - b.Position });
      })
      groups.sort((a, b) => { return a.PositionGroupe - b.PositionGroupe });

      resolve(groups);
    })
  })
}

function getUserModuleRights() {
  return new Promise((resolve, reject) => {
    apiFetch("module/right")
      .then(rights => {
        const res = rights.map(r => r.ModuleId);
        resolve(res);
      })
      .catch(e => reject(e));
  })
}

function verifyModuleRights(moduleUrl = "") {
  if (!moduleUrl) moduleUrl = getCurrentModuleUrl();
  if (!moduleUrl) return true // On est sur la page d'accueil

  return new Promise((resolve, reject) => {
      getModules().then(modules => {
        const module = modules.find(m => m.Url == moduleUrl);
        resolve(module ? true : false)
      })
  })
}

function getAllUserModuleRights() {
  return apiFetch("module/right/all");
}

function toggleUserModuleRight(userId, moduleId) {
  return apiFetch("module/right/toggle?userId=" + userId + "&moduleId=" + moduleId);
}

function updateAdminOnlyModuleStatus(moduleId, status) {
  return apiFetch("module/adminonly/toggle?moduleId=" + moduleId + "&status=" + status);
}

function updateIsPublicModuleStatus(moduleId, status) {
  return apiFetch("module/ispublic/toggle?moduleId=" + moduleId + "&status=" + status);
}

export default {
  getModules,
  getModuleGroups,
  getModulesInGroups,
  getUserModuleRights,
  verifyModuleRights,
  getAllUserModuleRights,
  toggleUserModuleRight,
  updateGroup,
  updatePosition,
  updateAdminOnlyModuleStatus,
  updateIsPublicModuleStatus
}
export {
  getModules,
  getModuleGroups,
  getModulesInGroups,
  getUserModuleRights,
  verifyModuleRights,
  getAllUserModuleRights,
  toggleUserModuleRight,
  updateGroup,
  updatePosition,
  updateAdminOnlyModuleStatus,
  updateIsPublicModuleStatus
}



// WEBPACK FOOTER //
// ./src/utils/module.js